/* unplugin-vue-components disabled */import script from "./UserBookingMetrics.vue?vue&type=script&setup=true&lang=js"
export * from "./UserBookingMetrics.vue?vue&type=script&setup=true&lang=js"

import "./UserBookingMetrics.vue?vue&type=style&index=0&id=297bf995&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297bf995"]])

export default __exports__